<template lang="pug">
nav.v-mobile-nav.mobile-nav(v-if="isSm")
	.mobile-nav__items
		.mobile-nav__item
			a.mobile-nav__link(href="/")
				v-svg-icon.mobile-nav__icon(icon="main-icon")
				.mobile-nav__text Главная
		.mobile-nav__item
			a.mobile-nav__link(href="/catalog/")
				v-svg-icon.mobile-nav__icon(icon="catalog-icon")
				.mobile-nav__text Каталог
		.mobile-nav__item
			v-favorite-small
		.mobile-nav__item(v-if="$slots['bonus']")
			slot(name="bonus")
		.mobile-nav__item
			button.mobile-nav__link(type="button" @click="toggleMobileNav")
				v-svg-icon.mobile-nav__icon(icon="more-icon")
				.mobile-nav__text Еще
	// ToDo: эта панель должна показываться только на карточке товара, но я не знаю какую проверку написать тут
	//-.mobile-nav__panel
	//-	button.btn.btn--primary.btn--sm.btn--block(type="button") Связаться
</template>

<script>
import controller from '../scripts/controller/controller.js';
import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {

		};
	},

	methods: {
		toggleMobileNav(e) {
			if (document.body.classList.contains('state--mob-menu-opened')) {
				controller.closeMobileNav();
				controller.unlockScrolling('.page-header__main-nav-wrap');
			} else {
				e.stopPropagation();
				controller.openMobileNav();
				controller.lockScrolling('.page-header__main-nav-wrap');
			}
		}
	}
};
</script>